import { checkboxCardStyles } from './checkbox-card.styles';
import { CheckboxOptions, NatGenCheckbox } from '../checkbox/checkbox';
import { checkboxCardTemplate } from './checkbox-card.template';
import { checkIcon, minusIcon } from '../../styles/icons';
import { applyMixins } from '../../foundation/apply-mixins';
import { StartEnd, StartEndOptions } from '../start-end/start-end';
import { NatGenDesignSystem } from '../../natgen-design-system';

export type CheckboxCardOptions = CheckboxOptions & StartEndOptions;

/**
 * @element natgen-checkbox-card
 */
export class NatGenCheckboxCard extends NatGenCheckbox {

}

export const natGenCheckboxCardDefinition = NatGenCheckboxCard.compose({
    name: `${NatGenDesignSystem.prefix}-checkbox-card`,
    template: checkboxCardTemplate({
        checkedIndicator: checkIcon,
        indeterminateIndicator: minusIcon
    }),
    styles: checkboxCardStyles
});

applyMixins(NatGenCheckboxCard, StartEnd);
